import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { grid } from '@noths/polaris-client-ribbons-base';
import { Image } from '@noths/polaris-client-ribbons-design-system';
import { Button, Icon } from '@noths/polaris-design-system-core-components';

import * as copy from '../copy';
import * as styles from './PartnerMaxiModule.styles';

export interface PartnerMaxiModuleProps {
  location: string;
  logoSrc: string;
  name: string;
  onContactPartnerClick: () => void;
  onLogoClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onPartnerNameClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onStorefrontClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onVisible?: () => void;
  onVisitShopClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  partnerLinkHref: string;
  partnerRating?: number;
  partnerReviewCount?: number;
}

export const PartnerMaxiModule = ({
  location,
  logoSrc,
  name,
  onContactPartnerClick,
  onLogoClick = () => {},
  onPartnerNameClick = () => {},
  onStorefrontClick = () => {},
  onVisible = () => {},
  onVisitShopClick = () => {},
  partnerLinkHref,
  partnerRating,
  partnerReviewCount,
}: PartnerMaxiModuleProps) => {
  const partnerModuleRef = useImpressionRef<HTMLDivElement>(() => onVisible?.());
  const partnerProductsHref = `${partnerLinkHref}#products`;
  const partnerOurStoryHref = `${partnerLinkHref}#ourstory`;
  const brandReviewsText = partnerReviewCount
    ? `(${partnerReviewCount.toLocaleString()} Brand reviews)`
    : '';

  return (
    <div css={[grid, styles.partner]} ref={partnerModuleRef}>
      {logoSrc && (
        <a
          css={styles.imageWrapper}
          href={partnerLinkHref}
          onClick={onLogoClick}
          rel="nofollow"
          tabIndex={-1}
        >
          <Image alt="partner logo" css={styles.image} loading="lazy" src={logoSrc} />
        </a>
      )}
      <div css={styles.content}>
        <h2 css={styles.heading}>
          <a href={partnerLinkHref} onClick={onPartnerNameClick} rel="nofollow">
            {name}
          </a>
        </h2>
        <ul css={styles.infoItems}>
          {location && (
            <li>
              <Icon name="location" size="sm" /> {location}
            </li>
          )}
          {partnerRating && (
            <li>
              <Icon name="starFull" size="sm" /> <strong>{partnerRating}</strong> {brandReviewsText}
            </li>
          )}
          <li>
            <a href={partnerOurStoryHref} onClick={onStorefrontClick}>
              <span>{copy.STOREFRONT_LINK_TEXT}</span>
              <Icon name="actionForward" size="sm" />
            </a>
          </li>
        </ul>
      </div>
      <div css={styles.buttons}>
        <Button
          compact
          fullWidth
          href={partnerProductsHref}
          iconLeft="partnerShop"
          onClick={onVisitShopClick}
          rel="nofollow"
          secondary
        >
          {copy.VISIT_SHOP_CTA}
        </Button>
        <Button
          compact
          fullWidth
          iconLeft="contactPartner"
          onClick={onContactPartnerClick}
          secondary
        >
          {copy.CONTACT_PARTNER_CTA}
        </Button>
      </div>
    </div>
  );
};
